




import { defineComponent, PropType } from '@nuxtjs/composition-api';

import { UCIconPrefix } from './types';

export default defineComponent({
  name: 'UCIcon',
  props: {
    icon: {
      type: String,
      required: true,
    },
    iconPrefix: {
      type: String as PropType<UCIconPrefix>,
      default: 'fa-solid',
    },
    size: {
      type: String,
      default: 'fa-md',
    },
    inverse: {
      type: Boolean,
      default: false,
    },
    duotone: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    computedIconClasses(): any {
      const prefix = this.duotone ? 'fa-duotone fa-light' : this.iconPrefix;
      return [prefix, this.icon, this.size, this.inverse ? 'fa-inverse' : ''].join(' ');
    },
  },
});
